/* eslint-disable no-underscore-dangle, no-alert */
import BookingService from '../../../Services/BookingService';

/**
 * Transition a Completed booking back to Confirmed so agents can edit it.
 * @param {object} deps
 */
export default (
  {
    setIsLoading, fetchOrders, setError,
  },
) => async (order) => {
  const reference = order.booking_reference || order._id;
  if (!window.confirm(`Revert booking ${reference} from Completed back to Confirmed?`)) {
    return;
  }
  setIsLoading(true);
  try {
    await BookingService.updateBookingFields(order._id, { status: 'Confirmed' });
    fetchOrders();
  } catch (err) {
    setError(err.response?.data?.message || err.message || 'Failed to revert booking.');
  } finally {
    setIsLoading(false);
  }
};
